import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSettings } from "@/lib/api";

const SettingsContext = createContext({ settings: null, loading: true });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchSettings()
      .then((d) => alive && setSettings(d))
      .catch(() => alive && setSettings(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return <SettingsContext.Provider value={{ settings, loading }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

export const useCta = () => {
  const { settings } = useSettings();
  return settings?.cta || {};
};
